import React from 'react';

import { getBenchmarkName, benchmarkSorter } from '../../../helpers/nameHelpers';
import * as helpers from '../portfolioHelpers';


function getBenchmarkRow(benchmark, currencyType, isPortfolio = false) {
    return <tr key={`cr1_${benchmark.name}`}>
        <td style={{ whiteSpace: 'nowrap' }}>{getBenchmarkName(benchmark.name, currencyType)}</td>
        <td>{helpers.formatCell(benchmark.portfolioAdjustedSharpeRatio, 'dec')}</td>
        <td>{helpers.formatCell(benchmark.averageReturn, '%')}</td>
        <td>{helpers.formatCell(benchmark.volReturn, '%')}</td>
        <td>{helpers.formatCell(benchmark.fivePercentVaR, '%')}</td>
        <td>{helpers.formatCell(benchmark.expectedShortfall, '%')}</td>
    </tr>
}

const Table = (props) => {

    const { portfolio } = props;
    const { reportData } = portfolio;

    const currencyType = portfolio.portfolio.data.currencyType;

    return <div>
        <table style={{ border: '1px solid black', borderCollapse: 'collapse' }}>
            <thead>
                <tr>
                    <th>Comparative Monthly Performance &amp; Risks Table 4</th>
                    <th>Adjusted Sharpe Ratio</th>
                    <th>Average Return</th>
                    <th>Volatility of Return</th>
                    <th>5% Value at Risk</th>
                    <th>Expected Shortfall</th>
                </tr>
                <tr>
                    <th >Client Portfolios</th>
                    <th>Monthly After Fees</th>
                    <th>Monthly After Fees</th>
                    <th>Monthly After Fees</th>
                    <th>Monthly After Fees</th>
                    <th>Monthly After Fees</th>
                </tr>
            </thead>
            <tbody>
                {getBenchmarkRow(reportData.portfolio, currencyType, true)}
                <tr>
                    <td colSpan={21} style={{ fontWeight: 'bold', paddingTop: 20 }}>Client Benchmarks for {reportData.portfolio.name}</td>
                </tr>
                {/* {reportData.benchmarks.filter(e => e.name === 'clientSpecified').map(benchmark => { return getBenchmarkRow(benchmark) })} */}
                {reportData.benchmarks.sort(benchmarkSorter).filter(e => (e.selected || (e.name === 'clientSpecified' || e.name === 'equalWeight'))).map(benchmark => { return getBenchmarkRow(benchmark,currencyType) })}
            </tbody>
        </table>
    </div>
};

export default Table;


// WEBPACK FOOTER //
// ./src/portfolio/components/ReportTables/ComparativeMonthlyTable4.js